import React, {ReactElement} from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import SignInCallback from './pages/Oidc/SignInCallback';
import SilentCallback from './pages/Oidc/SilentCallback';
import Routes from './Routes';
import SessionTimeout from "./components/SessionTimeout";
import {Auth0Provider, useAuth0} from '@auth0/auth0-react';


const domain = process.env.REACT_APP_OAUTH2_AUTHORITY!;
const clientId = process.env.REACT_APP_OAUTH2_CLIENT_ID!;
const audience = process.env.REACT_APP_OAUTH2_AUDIENCE; // optional, if you call an API



const ProtectedRoute = ({ children } : {children: ReactElement}) : ReactElement => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    React.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            // Send users to Auth0 and ask to be returned to the current URL
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    if (isLoading) return <div>Loading…</div>;
    if (!isAuthenticated) return <div>Loading…</div>; // We're redirecting—render nothing
    return children;
}



const Guard = () => (
    <Auth0Provider
        domain={domain}
        clientId={clientId}
        // Use refresh tokens in SPA for robust background renewal:
        useRefreshTokens
        useRefreshTokensFallback
        // Optionally persist across reloads (mind your threat model):
        // cacheLocation="localstorage"

        authorizationParams={{
            redirect_uri: window.location.origin,
            // redirect_uri: 'http://localhost:3001/oidc/sign-in-callback',
            // Ask for offline_access to receive a Refresh Token
            scope: 'openid profile email offline_access',
            ...(audience ? { audience } : {}),
        }}
    >
        <ProtectedRoute>
            <>
                <Routes/>
                <SessionTimeout/>
            </>
        </ProtectedRoute>
    </Auth0Provider>
);

const App = () => {


    return (
        <>
            <BrowserRouter>
                <Route path="/oidc/sign-in-callback" exact component={SignInCallback}/>
                <Route path="/oidc/silent-callback" exact component={SilentCallback}/>
                <Route path="/" component={Guard}/>
            </BrowserRouter>
        </>
    );
}

export default App;
